export const languages = { // 语言配置
    en: {
      navbar: { // 导航栏
        logo: "GIN TAROT",
        tabs: {
          character: "Choose Your Character",
          fortune: "Explore Fortune", 
          readings: "Your Reading"
        },
        login: "Login",
        profile: "Profile",
        myReadings: "My Readings",
        signOut: "Sign Out"
      },
      profile: { // 用户资料页面文本
        notLoggedIn: 'Please sign in to view your profile',
        memberSince: 'Member since',
        totalReadings: 'Total Readings',
        totalLogins: 'Total Logins', 
        firstVisit: 'First Visit',
        lastReading: 'Last Reading',
        never: 'Never',
        thanksMessage: 'Thank you for being part of our community!',
        journeyMessage: 'Your spiritual journey continues to unfold with each reading.',
        noActivityTitle: 'Welcome to GIN TAROT!',
        noActivityMessage: 'You have no activity yet. Start your first reading to begin your spiritual journey.',
        recentActivity: 'Recent Activity'
      },
      loginModal: { // 登录模态框
        title: "Gin Tarot",
        welcomeBack: "Welcome Back",
        joinCommunity: "Join Our Community",
        signInDescription: "Sign in to access your saved readings and continue your journey of self-discovery.",
        signUpDescription: "Create an account to save your readings and track your spiritual journey over time.",
        signIn: "Sign In",
        createAccount: "Create Account",
        signInPrompt: "Welcome back! Please enter your details",
        signUpPrompt: "Fill in your information to get started",
        noAccount: "Don't have an account? ",
        haveAccount: "Already have an account? ",
        signUpButton: "Sign up",
        signInButton: "Sign in",
        signingIn: "Signing In...",
        creatingAccount: "Creating Account..."
      },
      characterIntro: { // 角色介绍
        chooseGuide: "Choose as Guide"
      },
      userReadings: { // 用户阅读
        noReadingsTitle: "No Readings Yet",
        noReadingsText: "You haven't done any readings yet. Start your journey with a new reading!",
        startNewReading: "Start New Reading",
        sentimentLabels: {
          1: "Not happy at all",
          2: "Somewhat sad", 
          3: "Neutral",
          4: "Moderately delight",
          5: "Extreme ecstatic"
        },
        notRated: "Not rated",
        yourReadings: "Your Readings",
        beforeReading: "Before",
        afterReading: "After",
        selectReadingToView: "Select a reading to view details",
        interactiveReading: "Interactive Reading",
        additionalInsights: "Additional insights",
        summary: "Summary",
        readingSection: "Reading section"
      },
      confidenceRating: { // 信心评估
        continue: "Continue",
        rateYourFeelings: "Rate Your Feelings",
        submitRating: "Submit Rating",
        sentimentLabels: {
          1: "Not happy at all",
          2: "Somewhat sad",
          3: "Neutral", 
          4: "Moderately delight",
          5: "Extreme ecstatic"
        }
      },
      feedbackView: { // 反馈视图
        yourQuestion: "Your question:",
        initialConfidence: "Your initial confidence level was {level}/10. How do you feel now?",
        howFeel: "How much better do you feel after this reading?",
        thankYou: "Thank You!",
        submitFeedback: "Submit Feedback",
        pleaseSelect: "Please select a value on the slider to continue",
        improvementMessage: "Your confidence level has increased by {change} points. We're glad the reading was helpful!",
        noChangeMessage: "Your confidence level remains the same. We hope you found some insights in this reading.",
        decreaseMessage: "We notice your confidence level has decreased. Remember that tarot readings are just one perspective, and you have the power to shape your future.",
        generalGoodMessage: "We're glad the reading was helpful!",
        generalStressMessage: "We hope some of your stress has dissolved away with this reading."
      },
      rightReadingView: { // 阅读视图
        navigation: {
          previousCard: "Previous Card",
          nextCard: "Next Card", 
          previousQuestion: "Previous Question",
          nextQuestion: "Next Question",
          summary: "Summary",
          feedback: "Feedback"
        },
        buttons: {
          recordFeeling: "Record Your Feeling",
          askFollowUp: "Ask Follow-up",
          submitRating: "Submit Rating"
        },
        titles: {
          rateYourFeelings: "Rate Your Feelings"
        }
      },
      rightQuestion: { // 问题组件
        placeholder: "Ask a follow-up question...",
        consultingCards: "Consulting the cards...",
        rateYourFeelings: "Rate Your feelings",
        submitRating: "Submit Rating",
        followUpPrompt: "To follow up on your reading, what do you want to ask more about?",
        conversationEffect: "How has this conversation affected your feelings about this question?",
        errorMessage: "I'm sorry, I couldn't process your question. Please try again."
      },
      npcSelection: { // NPC选择页面
        hoverReveal: "Hover over a card to reveal secrets!"
      },
      characterInfoWindow: { // 角色信息窗口
        chooseGuide: "Choose as Guide"
      },
      questionSplit: { // 问题拆分组件
        continue: "Continue",
        mysticGuide: "Mystic Guide",
        chooseReadingType: "Choose your reading type:",
        dailyReading: "Daily Reading",
        weeklyReading: "Weekly Reading",
        discoverYourPath: "Discover your path for today",
        planYourWeek: "Plan your week ahead",
        bothReadingsNote: "Both readings use a single card to provide focused guidance",
        whatWouldYouLikeToKnow: "What would you like to know?",
        drawingCards: "I'm drawing the cards for your reading now...",
        goodToKnow: "Good to know.",
        chooseFramework: "Please choose the framework that best fits your question:",
        consultingCards: "Consulting the cards...",
        askYourOwnQuestion: "Or ask your own question...",
        beginReading: "Begin Reading"
      },
      characters: { // 角色数据
        the_fool: {
          title: "The Fool",
          subtitle: "Adventurous Spirit",
          personality: ["Adventurous", "Creative", "Curious"],
          description: "I am The Fool—always filled with curiosity, an open mind, and a desire to explore. I see problems with fresh eyes, inspire innovative ideas, and embrace the unknown.",
          emotion_guidence: "Before choosing, jump and describe your current mood—the wild dance of your soul!",
          intro: "You're about to embark on a journey of self-discovery. To help you find the best answers, I'll guide you through a series of questions, or you can directly input your question at the continue button. Let's begin!",
          dialogue1: "Choose the most important area of your question from the following list:",
          dialogue2: "This question is about...?",
          interests: ["Career", "Love", "Health", "Finance", "Family", "Friendship", "Personal Growth"],
          type: ["What will happen if...", "Should I start..."],
          fortune_dialogue: "I am The Fool, and I will guide you through daily or weekly fortune readings.",
          fortune_guidence: "Would you like an exciting daily fortune reading full of new discoveries, or an adventurous weekly fortune reading that offers fresh possibilities for the week ahead?"
        },
        the_hanged_man: {
          title: "The Hanged Man",
          subtitle: "Wise Mentor",
          personality: ["Wisdom", "Patience", "Sacrifice"],
          description: "I am The Hanged Man—guiding you through patience, letting go, and perspective shifts. My wisdom lies in embracing challenges, finding clarity in sacrifice, and growing in stillness.",
          emotion_guidence: "Pause for a moment, shift your perspective, and release the truth of your mood before choosing",
          intro: "You're about to embark on a journey of self-discovery. To help you find the best answers, I'll guide you through a series of questions, or you can directly input your question at the continue button. Let's begin!",
          dialogue1: "Choose the most important area of your question from the following list:",
          dialogue2: "This question is about...?",
          interests: ["Career", "Love", "Health", "Finance", "Family", "Friendship", "Personal Growth"],
          type: ["What will happen if...", "Should I start..."],
          fortune_dialogue: "I am The Hanged Man, and I will guide you through daily or weekly fortune readings.",
          fortune_guidence: "Would you like a thoughtful daily fortune reading that provides guidance for today, or a weekly fortune reading that offers deep insights and wisdom for the entire week?"
        },
        the_magician: {
          title: "The Magician",
          subtitle: "Creative Innovator",
          personality: ["Innovation", "Adventure", "Imagination"],
          description: "I am The Magician—bringing imaginative solutions and bold creativity. Obstacles are opportunities; let's take risks, innovate, and transform challenges into victories.",
          emotion_guidence: "Before choosing, summon the truth of your current mood—shape it, speak it, and let the magic unfold!",
          intro: "You're about to embark on a journey of self-discovery. To help you find the best answers, I'll guide you through a series of questions, or you can directly input your question at the continue button. Let's begin!",
          dialogue1: "Choose the most important area of your question from the following list:",
          dialogue2: "This question is about...?",
          interests: ["Career", "Love", "Health", "Finance", "Family", "Friendship", "Personal Growth"],
          type: ["What will happen if...", "Should I start..."],
          fortune_dialogue: "I am The Magician, and I will guide you through daily or weekly fortune readings.",
          fortune_guidence: "Would you like a bold daily fortune reading full of exciting opportunities, or a weekly fortune reading that sparks imaginative ideas?"
        },
        the_priestess: {
          title: "The Priestess",
          subtitle: "Intuitive Guide",
          personality: ["Empathy", "Support", "Collaboration"],
          description: "I am The Priestess—offering empathetic insights, intuitive wisdom, and creative support. Together we nurture growth, collaborate, and find compassionate solutions.",
          emotion_guidence: "Take a deep breath, listen to the inner whispers, and reveal the truth of your mood before choosing",
          intro: "You're about to embark on a journey of self-discovery. To help you find the best answers, I'll guide you through a series of questions, or you can directly input your question at the continue button. Let's begin!",
          dialogue1: "Choose the most important area of your question from the following list:",
          dialogue2: "This question is about...?",
          interests: ["Career", "Love", "Health", "Finance", "Family", "Friendship", "Personal Growth"],
          type: ["What will happen if...", "Should I start..."],
          fortune_dialogue: "I am The Priestess, and I will guide you through daily or weekly fortune readings.",
          fortune_guidence: "Would you like a compassionate daily fortune reading that provides immediate insights, or a weekly fortune reading designed to nurture connection and growth?"
        }
      },
      header: {
        logo: "GIN TAROT",
        menuItems: [
          { label: "Selected Work", path: "/selected-work" },
          { label: "About", path: "/about" },
          { label: "Contact", path: "/contact" }
        ]
      },
      about: {
        title: "GIN TAROT",
        subtitle: "Fortune Awaits",
        selectCharacter: "Select Your Character",
        dailyFortune: "Explore Daily/Weekly Fortune",
        description: {
          default: "Step into a lively tarot world where dynamic NPCs guide and light up your path",
          character: "Start a tarot adventure by choosing a guide for your entire journey!",
          fortune: "Quickly uncover your weekly/daily fortune with a randomized guide!"
        }
      },
      privacyPolicy: { // 隐私政策页面
        title: "Privacy Policy",
        description: "Your privacy is important to us. Please review our complete privacy policy.",
        linkText: "View our full Privacy Policy"
      },
      termsOfService: { // 服务条款页面
        title: "Terms of Service",
        description: "Please review our terms of service to understand the rules and guidelines for using our application.",
        linkText: "View our full Terms of Service"
      },
    detailNPC: { // DetailNPC组件
      loadingMessages: [
        "Your chosen NPC is conjuring your cards from the cosmic deck...",
        "Your chosen NPC is channeling the whispers of fate into your question...",
        "Your chosen NPC is weaving the threads of insight into a tapestry of revelation!"
      ],
      redirectMessages: {
        improved: "Congratulations on your emotional growth!",
        same: "Keep exploring your inner wisdom...",
        worse: "Don't worry, brighter days are ahead...",
        improvedText: "Your journey of self-discovery is showing wonderful progress. Keep nurturing this positive change!",
        sameText: "Every reading is a step forward in your journey. The insights you've gained will continue to guide you.",
        worseText: "Remember that every challenge is an opportunity for growth. The cards have shown you the path forward.",
        redirectText: "You will be redirected to your reading history..."
      },
      fortuneQuestions: { // 运势问题
        daily: "What does the universe have in store for me today?",
        weekly: "What should I focus on this week?"
      },
      readingSummary: "Reading Summary" // 解读总结标题
    }
    },
    zh: {
      navbar: { // 导航栏
        logo: "GIN TAROT",
        tabs: {
          character: "选择塔罗师",
          fortune: "每日运势",
          readings: "我的解读"
        },
        login: "登录",
        profile: "个人中心",
        myReadings: "我的解读",
        signOut: "退出登录"
      },
      profile: { // 用户资料页面中文文本
        notLoggedIn: '请登录后查看您的个人资料',
        memberSince: '注册时间',
        totalReadings: '总解读次数',
        totalLogins: '登录次数', 
        firstVisit: '首次访问',
        lastReading: '最近解读',
        never: '从未',
        thanksMessage: '感谢您成为我们社区的一员！',
        journeyMessage: '您的心灵之旅在每一次解读中不断展开。',
        noActivityTitle: '欢迎来到GIN TAROT！',
        noActivityMessage: '您还没有任何活动记录。开始您的首次解读，踏上心灵探索之旅。',
        recentActivity: '最近活动'
      },
      loginModal: { // 登录模态框
        title: "GIN TAROT",
        welcomeBack: "欢迎回来",
        joinCommunity: "加入我们",
        signInDescription: "登录以查看你过往的解读，继续你的自我探索之旅。",
        signUpDescription: "创建账户即可保存你的解读，随时回顾心灵成长之旅。",
        signIn: "登录",
        createAccount: "创建账户",
        signInPrompt: "欢迎回来！请输入你的信息",
        signUpPrompt: "填写信息，即刻开始",
        noAccount: "还没有账户？",
        haveAccount: "已有账户？直接登录",
        signUpButton: "注册",
        signInButton: "登录",
        signingIn: "正在登录...",
        creatingAccount: "正在创建账户..."
      },
      characterIntro: { // 角色介绍
        chooseGuide: "选为我的塔罗师"
      },
      userReadings: { // 用户阅读
        noReadingsTitle: "你还没有任何解读记录",
        noReadingsText: "开始一段新的探索之旅吧！",
        startNewReading: "开始新的解读",
        sentimentLabels: {
          1: "糟透了",
          2: "有点难过",
          3: "一般般",
          4: "还不错",
          5: "超开心"
        },
        notRated: "未评价",
        yourReadings: "你的解读",
        beforeReading: "解读前",
        afterReading: "解读后",
        selectReadingToView: "选择一个解读查看详情",
        interactiveReading: "互动解读",
        additionalInsights: "额外洞见",
        summary: "总结",
        readingSection: "解读部分"
      },
      confidenceRating: { // 信心评估
        continue: "继续",
        rateYourFeelings: "评价一下你的感受",
        submitRating: "提交评价",
        sentimentLabels: {
          1: "糟透了",
          2: "有点难过",
          3: "一般般",
          4: "还不错",
          5: "超开心"
        }
      },
      feedbackView: { // 反馈视图
        yourQuestion: "你的问题：",
        initialConfidence: "你最初的心情指数是 {level}/10。解读之后，现在感觉怎么样？",
        howFeel: "这次解读在多大程度上改善了你的心情？",
        thankYou: "谢谢你！",
        submitFeedback: "提交反馈",
        pleaseSelect: "请在滑块上选择一个数值",
        improvementMessage: "你的心情指数提升了 {change} 点。很高兴这次解读对你有帮助！",
        noChangeMessage: "你的心情指数保持不变。希望这次解读能为你带来一些启发。",
        decreaseMessage: "我们注意到你的心情指数有所下降。请记住，塔罗牌提供的只是一种视角，而你才是塑造自己未来的力量。",
        generalGoodMessage: "很高兴这次解读对你有帮助！",
        generalStressMessage: "希望这次解读帮你释放了一些压力。"
      },
      rightReadingView: { // 阅读视图
        navigation: {
          previousCard: "上一张牌",
          nextCard: "下一张牌",
          previousQuestion: "上个问题",
          nextQuestion: "下个问题",
          summary: "总结",
          feedback: "反馈"
        },
        buttons: {
          recordFeeling: "记录我的感受",
          askFollowUp: "提出追问",
          submitRating: "提交评价"
        },
        titles: {
          rateYourFeelings: "评价你的感受"
        }
      },
      rightQuestion: { // 问题组件
        placeholder: "提出一个追问...",
        consultingCards: "正在解读牌意...",
        rateYourFeelings: "评价你的感受",
        submitRating: "提交评价",
        followUpPrompt: "关于本次解读，你还有什么想深入了解的吗？",
        conversationEffect: "这次对话对你关于这个问题的感受有什么影响？",
        errorMessage: "抱歉，无法处理你的问题，请再试一次。"
      },
      npcSelection: { // NPC选择页面
        hoverReveal: "将鼠标悬停在卡牌上，揭晓它的秘密！"
      },
      characterInfoWindow: { // 角色信息窗口
        chooseGuide: "选为我的塔罗师"
      },
      characters: { // 角色数据
        the_fool: {
          title: "愚人",
          subtitle: "踏上未知旅程的冒险家",
          personality: ["冒险", "开创", "好奇"],
          description: "我是愚人——永远充满好奇、思想开放、渴望探索。我用全新的视角看待问题，激发创新的想法，拥抱一切未知。",
          emotion_guidence: "选择之前，先释放你此刻的心情——像灵魂在自由舞蹈一样告诉我！",
          intro: "你即将踏上一段自我发现的旅程。为了帮你找到最好的答案，我会引导你完成一系列提问，当然，你也可以直接输入你的问题。让我们开始吧！",
          dialogue1: "从下面的选项中，选出你的问题最相关的领域：",
          dialogue2: "这个问题是关于……？",
          interests: ["事业", "爱情", "健康", "财富", "家庭", "友谊", "个人成长"],
          type: ["如果...会怎样？", "我是否应该开始..."],
          fortune_dialogue: "我是愚人，让我来指引你今日或本周的运势。",
          fortune_guidence: "你想要一份充满新发现的每日运势解读，还是一次为未来一周开启无限可能的每周运势探索？"
        },
        the_hanged_man: {
          title: "倒吊人",
          subtitle: "换个角度看世界的智者",
          personality: ["智慧", "耐心", "放下"],
          description: "我是倒吊人——我将引导你学会耐心、放下执念、转换视角。我的智慧在于拥抱挑战，在放手中豁然开朗，在沉静中获得成长。",
          emotion_guidence: "在选择前，请暂停片刻，换个角度，感受你最真实的心情。",
          intro: "你即将踏上一段自我发现的旅程。为了帮你找到最好的答案，我会引导你完成一系列提问，当然，你也可以直接输入你的问题。让我们开始吧！",
          dialogue1: "从下面的选项中，选出你的问题最相关的领域：",
          dialogue2: "这个问题是关于……？",
          interests: ["事业", "爱情", "健康", "财富", "家庭", "友谊", "个人成长"],
          type: ["如果...会怎样？", "我是否应该开始..."],
          fortune_dialogue: "我是倒吊人，让我来指引你今日或本周的运势。",
          fortune_guidence: "你想要一份为你今日之路提供沉思指引的每日解读，还是一份为未来整周带来深刻洞见的每周指引？"
        },
        the_magician: {
          title: "魔术师",
          subtitle: "化腐朽为神奇的创造者",
          personality: ["创新", "冒险", "想象"],
          description: "我是魔术师——我能带来富有想象力的解决方案和大胆的创造力。障碍亦是机遇；让我们一起冒险、创新，将挑战化为胜利。",
          emotion_guidence: "选择之前，请召唤你此刻最真实的心情——将它塑造成型，大声说出，见证奇迹的发生！",
          intro: "你即将踏上一段自我发现的旅程。为了帮你找到最好的答案，我会引导你完成一系列提问，当然，你也可以直接输入你的问题。让我们开始吧！",
          dialogue1: "从下面的选项中，选出你的问题最相关的领域：",
          dialogue2: "这个问题是关于……？",
          interests: ["事业", "爱情", "健康", "财富", "家庭", "友谊", "个人成长"],
          type: ["如果...会怎样？", "我是否应该开始..."],
          fortune_dialogue: "我是魔术师，让我来指引你今日或本周的运势。",
          fortune_guidence: "你想要一次充满惊喜机遇的每日运势解读，还是一次能激发无限创意的每周运势探索？"
        },
        the_priestess: {
          title: "女祭司",
          subtitle: "倾听内在声音的倾听者",
          personality: ["共情", "支持", "协作"],
          description: "我是女祭司——我能提供共情的洞察、直觉的智慧和创造性的支持。让我们一起滋养成长、携手合作，找到充满善意的解决方案。",
          emotion_guidence: "选择之前，请深呼吸，倾听内心的低语，告诉我你此刻的真实感受。",
          intro: "你即将踏上一段自我发现的旅程。为了帮你找到最好的答案，我会引导你完成一系列提问，当然，你也可以直接输入你的问题。让我们开始吧！",
          dialogue1: "从下面的选项中，选出你的问题最相关的领域：",
          dialogue2: "这个问题是关于……？",
          interests: ["事业", "爱情", "健康", "财富", "家庭", "友谊", "个人成长"],
          type: ["如果...会怎样？", "我是否应该开始..."],
          fortune_dialogue: "我是女祭司，让我来指引你今日或本周的运势。",
          fortune_guidence: "你想要一份能提供即时洞见的每日解读，还是一次旨在滋养人际与内在成长的每周指引？"
        }
      },
      header: {
        logo: "GIN TAROT",
        menuItems: [
          { label: "精选案例", path: "/selected-work" },
          { label: "关于我们", path: "/about" },
          { label: "联系方式", path: "/contact" }
        ]
      },
      about: {
        title: "GIN TAROT",
        subtitle: "探寻你的命运",
        selectCharacter: "选择你的塔罗师",
        dailyFortune: "探索每日/每周运势",
        description: {
          default: "进入一个充满活力的塔罗世界，让你的专属塔罗师为你照亮前路。",
          character: "选择一位塔罗师，开启你的塔罗冒险之旅！",
          fortune: "让随机塔罗师为你快速揭晓每日或每周运势！"
        }
      },
      questionSplit: { // 问题拆分组件
        continue: "继续",
        mysticGuide: "你的专属塔罗师",
        chooseReadingType: "选择你的解读类型：",
        dailyReading: "今日解读",
        weeklyReading: "本周解读",
        discoverYourPath: "探索今日之路",
        planYourWeek: "规划未来一周",
        bothReadingsNote: "两种解读都只用一张牌，为你提供最核心的指引。",
        whatWouldYouLikeToKnow: "你有什么想问的？",
        drawingCards: "正在为你抽牌...",
        goodToKnow: "明白了。",
        chooseFramework: "请选择最适合你问题的牌阵：",
        consultingCards: "正在为你解牌...",
        askYourOwnQuestion: "或提出你自己的问题...",
        beginReading: "开始解读"
      },
      privacyPolicy: { // 隐私政策页面
        title: "隐私政策",
        description: "我们非常重视你的隐私。请查阅我们完整的隐私政策。",
        linkText: "查看完整隐私政策"
      },
      termsOfService: { // 服务条款页面
        title: "服务条款",
        description: "请查阅我们的服务条款，了解使用本应用的规则与指南。",
        linkText: "查看完整服务条款"
      },
    detailNPC: { // DetailNPC组件
      loadingMessages: [
        "你的塔罗师正在从宇宙牌库中为你召唤卡牌...",
        "你的塔罗师正在将命运的低语注入你的问题...",
        "你的塔罗师正在将洞见的丝线编织成一张为你揭示未来的启示图！"
      ],
      redirectMessages: {
        improved: "恭喜你，你的内心又成长了一步！",
        same: "继续探索你内心的智慧吧...",
        worse: "别担心，风雨过后总会有彩虹...",
        improvedText: "你的自我发现之旅正取得美好的进展，请继续保持这份积极的改变！",
        sameText: "每一次解读都是你旅程中的一次迈进。你所获得的洞见将继续为你指路。",
        worseText: "请记住，每个挑战都是成长的契机。牌阵已经为你指明了前进的方向。",
        redirectText: "即将跳转到你的解读历史..."
      },
      fortuneQuestions: { // 运势问题
        daily: "宇宙今天为我准备了什么？",
        weekly: "我这周应该关注什么？"
      },
      readingSummary: "解读总结" // 解读总结标题
    },
    frameworks: { // 框架翻译映射
      "Their Mind-Relationship Flow-Your Move": "对方想法-关系走向-你的行动",
      "Challenge-Solution-Evolution": "挑战-对策-发展",
      "Current-Future-Opportunity": "现状-未来-机遇",
      "Resource-Action-Reward": "资源-行动-回报",
      "Now-Challenge-Future": "现状-挑战-未来",
      "Skill-Potential-Opportunity": "技能-潜力-机遇",
      "Now-Block-Potential": "现状-阻碍-潜力",
      "Mind-Spirit-Guide": "心智-心灵-指引",
      "Event-Emotion-Reflection": "事件-情绪-反思",
      "Daily Fortune": "每日运势",
      "Weekly Guidance": "每周指引"
    },
      frameworkDescriptions: { // 框架描述翻译映射
        // Relationships
        "This framework delves into the thoughts and feelings of the other person, analyzes current relationship dynamics, and suggests a strategic action to navigate complex interpersonal situations.": "此牌阵能深入探究对方的想法与感受，分析当前关系的动态，并为你下一步的行动提供策略性建议，助你应对复杂的人际状况。",
        "This framework identifies specific challenges, offers actionable solutions, and forecasts relationship evolution to overcome obstacles and foster growth.": "此牌阵能帮你识别关系中的具体挑战，提供可行的解决方案，并预测关系的发展方向，从而克服障碍，促进成长。",
        // Wealth
        "This framework provides a clear snapshot of current financial status, projects future trends, and highlights upcoming opportunities for strategic planning.": "此牌阵能清晰地展示你当前的财务状况，预测未来的趋势，并为你点明即将到来的机遇，以便进行战略规划。",
        "This framework evaluates available resources, recommends specific actions, and predicts potential rewards to maximize financial outcomes.": "此牌阵能帮你评估手头的资源，推荐具体的行动方案，并预测潜在的回报，从而实现财务收益最大化。",
        // Career
        "This framework assesses current professional standing, anticipates upcoming challenges, and envisions future career trajectories for effective planning.": "此牌阵能评估你目前的职业状况，预见即将到来的挑战，并展望未来的职业发展轨迹，助你进行有效规划。",
        "This framework evaluates existing skills, uncovers untapped potential, and identifies emerging opportunities to facilitate career advancement.": "此牌阵能评估你的现有技能，发掘尚未开发的潜力，并识别新兴机会，以促进你的职业发展。",
        // Self-Growth
        "This framework examines the current state, identifies internal or external blocks, and reveals latent potential to drive personal development.": "此牌阵能审视你的现状，识别内在或外在的障碍，并揭示驱动个人成长的潜在力量。",
        "This framework explores mental and spiritual states while offering guidance for holistic development and balanced personal evolution.": "此牌阵能探索你的心智与精神状态，同时为你的全面发展和均衡的个人成长提供指引。",
        // Daily/Weekly Guidance
        "This framework processes daily/weekly events, clarifies emotional responses, and provides reflective insights to foster daily/weekly awareness.": "此牌阵能梳理每日或每周的事件，厘清你的情绪反应，并提供反思性的见解，以培养你对每日或每周生活的觉察力。"
      }
    }
  };
  
  import { useState, useEffect } from 'react'; // React hooks导入
  
  export const LANGUAGE_CHANGE_EVENT = 'languageChange'; // 语言变更事件
  
  export const getLanguage = () => { // 获取当前语言
    const params = new URLSearchParams(window.location.search);
    return params.get('lang') || 'en';
  };
  
  export const setLanguage = (lang) => { // 设置语言并更新URL，触发响应式更新
    const url = new URL(window.location);
    url.searchParams.set('lang', lang);
    window.history.pushState({}, '', url);
    window.dispatchEvent(new CustomEvent(LANGUAGE_CHANGE_EVENT, { detail: { language: lang } })); // 触发事件
  };
  
  export const useLanguage = () => { // 响应式语言Hook
    const [currentLang, setCurrentLang] = useState(getLanguage());
    
    useEffect(() => {
      const handleLanguageChange = (event) => setCurrentLang(event.detail.language);
      const handlePopstate = () => setCurrentLang(getLanguage()); // 处理浏览器前进后退
      
      window.addEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
      window.addEventListener('popstate', handlePopstate);
      return () => {
        window.removeEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
        window.removeEventListener('popstate', handlePopstate);
      };
    }, []);
    
    return currentLang;
  };
  
  export const navigateWithLang = (navigate, path, options = {}) => { // 保持语言参数的导航函数
    const currentLang = getLanguage();
    const url = new URL(path, window.location.origin);
    if (currentLang !== 'en') url.searchParams.set('lang', currentLang);
    navigate(url.pathname + url.search, options);
  };
  
  export const translateFramework = (framework, language) => { // 框架翻译函数
    if (language === 'zh' && languages.zh.frameworks[framework]) {
      return languages.zh.frameworks[framework];
    }
    return framework; // 返回原英文
  };
  
  export const translateFrameworkDescription = (description, language) => { // 框架描述翻译函数
    if (language === 'zh' && languages.zh.frameworkDescriptions[description]) {
      return languages.zh.frameworkDescriptions[description];
    }
    return description; // 返回原英文
  };

  export const translateFortuneQuestion = (type, language) => { // 运势问题翻译函数
    const englishQuestion = type === 'daily'
      ? "What does the universe have in store for me today?"
      : "What should I focus on this week?";

    if (language === 'zh' && languages.zh.detailNPC.fortuneQuestions) {
      return type === 'daily'
        ? languages.zh.detailNPC.fortuneQuestions.daily
        : languages.zh.detailNPC.fortuneQuestions.weekly;
    }
    return englishQuestion; // 返回原英文
  };